/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseCohortData } from './genericApiResponseCohortData';
import type { GenericApiResponseCohortMessage } from './genericApiResponseCohortMessage';
import type { GenericApiResponseCohortPagination } from './genericApiResponseCohortPagination';
import type { GenericApiResponseCohortError } from './genericApiResponseCohortError';

export interface GenericApiResponseCohort {
  data?: GenericApiResponseCohortData;
  message?: GenericApiResponseCohortMessage;
  pagination?: GenericApiResponseCohortPagination;
  error?: GenericApiResponseCohortError;
  statusCode?: number;
}
